import React, { useMemo } from "react"
import { Immutable, State, useHookstate } from "@hookstate/core"
import { Validation } from "@hookstate/validation"
import { RefCategory, ReferenceDataState, useReferenceDataState } from "../../globalStates/ReferenceDataState"
import { useProductPropertiesDataState } from "../../globalStates/ProductPropertiesState"
import { Product } from "../../globalStates/ExhibitorDataTypes"
import AddProductProperty from "./AddProductProperty"

interface ProductInformationContainsProps {
    index: number
    product: State<Product, Validation>
}

function buildProductTypeOptions(refTypes: any) {
    return refTypes.map((refType: { id: any; name: string }) => ({ id: refType.id, label: refType.name, value: refType.id }))
}

function getProductTypesName(refDataState: ReferenceDataState, refTypes: any) {
    let categories: (Immutable<RefCategory> | undefined)[] = []
    refTypes.map((refType: { id: any }) => {
        return categories.push(refDataState.getCategory(refType.id.get()))
    })

    return categories
}

const ProductInformationContents: React.FC<ProductInformationContainsProps> = ({ product }) => {
    const productPropertyState = useHookstate(product)
    const productPropertiesDataState = useProductPropertiesDataState()
    const properties = productPropertiesDataState.getProductTypes()

    const refDataState = useReferenceDataState()
    const productTypesName = useMemo(
        () => getProductTypesName(refDataState, properties.properties),
        [properties.properties, refDataState]
    )
    const productTypesOptions = useMemo(() => buildProductTypeOptions(productTypesName), [productTypesName])

    return (
        <>
            <AddProductProperty
                id={productPropertyState.id.get()}
                productPropertyState={productPropertyState}
                propertiesOptions={productTypesOptions}
            />
        </>
    )
}

export default ProductInformationContents
